import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const verifyLoginCode = async (email: string, code: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: 'verify-login-code',
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        params: {
            email,
            code
        }
    });
}